import { Box } from '@mui/material'
import { PropsWithChildren } from 'react'
import { GoBack } from 'src/pages/admin/router/components/GoBack'

interface WrapperTableProps {
    goBackTo?: string
}

export function WrapperTable({ children, goBackTo }: PropsWithChildren<WrapperTableProps>) {
    return (
        <Box>
            <Box mb={1}>
                <GoBack to={goBackTo} />
            </Box>
            {children}
        </Box>
    )
}
